import React from "react";
import "./styles/PromoPageView.scss";
import Markdown from 'react-markdown'
import {BadgeList} from "../contenful/types";


interface Props {
        section : BadgeList;
        mobile : boolean;
}

const Badges: React.FC<Props> = ({section}) => {
        if(!section) {
                return <></>
        }
        return (<div className={`badges-container ${section.cssClassName ?? ''}`}>
                        {section.badges && section.badges.map((badge: any, idx: any) => {
                                return <div key={idx} className={`badge-content ${badge.cssClassName ?? ''}`}>
                                        {badge && badge.icon && badge.icon.fields && !badge.badgeImage &&
                                                <img src={badge && badge.icon && badge.icon.fields && badge.icon.fields.file.url} className="badge-icon" />}
                                        {badge && badge.text && !badge.badgeImage &&
                                                <div className="badge-text"><Markdown children={badge.text} /></div>}
                                        {badge && badge.badgeImage &&
                                                <img src={badge.badgeImage && badge.badgeImage.fields.file.url}
                                                className={`badge-image ${idx}`} />}
                                </div>
                        })}
                </div>)

}

export default Badges;